import React, { useEffect, useState, useRef, useMemo } from 'react'
import './login.scss';
import LoginLeft from './LoginLeft';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { useHistory, useLocation } from 'react-router';
import Notify from 'lib/Utils/Alert';
import Authenticate from 'lib/Core/Authenticate';
import NotificationAlert from "react-notification-alert";
import Spinner from 'react-bootstrap/Spinner';

const securityGroups = [
	"purchaser"
]

const ChangePassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [confirmShowPassword, setConfirmShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState(null);
  const [passwordLoader,setPasswordLoader] = useState(false)
  const history = useHistory();
  const notifyRef = useRef();
  const location = useLocation();
  const {state} = location
const  session = JSON.parse(sessionStorage.getItem("session"));
const  username = JSON.parse(sessionStorage.getItem("username"));
  const checkPassword = () => {
    const hasUpperCase = /[A-Z]/; 
    const hasLowerCase = /[a-z]/; 
    const hasNumber = /[0-9]/;    
    const hasSpecialChar = /[!@#?$%*&]/;
    const minLength = /^.{8,}$/; 

    
    if (!minLength.test(password)) {
      setPasswordError("Password must be at least 8 characters long.");
      return;
  }

  if (!hasUpperCase.test(password)) {
    setPasswordError("Password must include at least one uppercase letter.");
      return;
  }

  if (!hasLowerCase.test(password)) {
    setPasswordError("Password must include at least one lowercase letter.");
      return;
  }

  if (!hasNumber.test(password)) {
    setPasswordError("Password must include at least one number.");
      return;
  }

  if (!hasSpecialChar.test(password)) {
    setPasswordError("Password must include at least one special character (!, @, #, ?,$,%,&,*).");
      return;
  }

    
      setPasswordError(null)
    
  }

  const checkConfirmPassword = () => {
    const hasUpperCase = /[A-Z]/; 
    const hasLowerCase = /[a-z]/; 
    const hasNumber = /[0-9]/;    
    const hasSpecialChar = /[!@#?$%*&]/;
    const minLength = /^.{8,}$/; 

    if (!minLength.test(confirmPassword)) {
        setConfirmPasswordError("Password must be at least 8 characters long.");
        return;
    }

    if (!hasUpperCase.test(confirmPassword)) {
        setConfirmPasswordError("Password must include at least one uppercase letter.");
        return;
    }

    if (!hasLowerCase.test(confirmPassword)) {
        setConfirmPasswordError("Password must include at least one lowercase letter.");
        return;
    }

    if (!hasNumber.test(confirmPassword)) {
        setConfirmPasswordError("Password must include at least one number.");
        return;
    }

    if (!hasSpecialChar.test(confirmPassword)) {
        setConfirmPasswordError("Password must include at least one special character (!, @, #, ?,$,&,%,*).");
        return;
    }

    setConfirmPasswordError(null);
};

  const authCtl = useMemo(() => new Authenticate(securityGroups), [securityGroups]);

	function NotifyError(msg)
	{
		Notify(notifyRef, "danger", msg);
	}

  const changePasswordSubmit = () => {
   
    setPasswordLoader(true)
   if(passwordError == null && confirmPasswordError == null ){

    if (password !== confirmPassword)
    {
      NotifyError("The passwords don't match, please verify.");
      setTimeout(() => {
        setPasswordLoader(false)
      }, 1500);
    }
    else
    {
      authCtl.forcePasswordChange(session, username, password).then(data =>
      {
        // NotifySuccess("Password updated successfully, please login with your new password.");
        sessionStorage.removeItem("session");
        history.replace("/purchaser-auth/login", {state: {msg : "Password updated successfully, please login with your new password."}})
        setTimeout(() => {
          setPasswordLoader(false)
        }, 1500);
      }).catch(NotifyError=>{
        setTimeout(() => {
          setPasswordLoader(false)
        }, 1500);
      })
    }
    }
    else {
      checkConfirmPassword();
      setTimeout(() => {
        setPasswordLoader(false)
      }, 1500);
      checkPassword();
    }
    
  }

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        if (passwordError === null && confirmPasswordError === null) {
          changePasswordSubmit()
        }
        else {
          checkConfirmPassword();
          checkPassword();
        }
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [passwordError, confirmPasswordError]);

  return (
    <div className='authPage'>
      <NotificationAlert ref={notifyRef} />
      <div className="wrap">
        <div className="row g-0">
          <div className="col-lg-6">
            <LoginLeft hideCursor={true}/>
          </div>

          <div className="col-lg-6">
            <div className="authRight h-100 p-4 p-lg-5">
              <div className='authRightContent'>
                <img src="../../assets/img/ncentiva.png" alt="" className='mb-3 d-block d-lg-none' />
                <h3>Change Password</h3>
                <div className="formField">
                  <label htmlFor="">New Password</label>
                  <div className="position-relative">
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon2"><i className='bx bxs-lock' ></i></InputGroup.Text>
                      <Form.Control
                        placeholder="Enter your password"
                        aria-label="password"
                        aria-describedby="basic-addon2"
                        type={showPassword ? 'text' : 'password'}
                        className={`pe-5 ${passwordError && 'border-danger'}`}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyUp={checkPassword}
                      />
                    </InputGroup>
                    <button className='btn-pass position-absolute end-0 top-0 text-primary h-100 px-3 bg-transparent border-0' onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                    </button>
                  </div>
                  {passwordError && <p className='text-danger mb-2' style={{ marginTop: '-10px', paddingLeft: '40px' }}>{passwordError}</p>}
                </div>
                <div className="formField">
                  <label htmlFor="">Confirm Password</label>
                  <div className="position-relative">
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon2"><i className='bx bxs-lock' ></i></InputGroup.Text>
                      <Form.Control
                        placeholder="Enter your password"
                        aria-label="password"
                        aria-describedby="basic-addon2"
                        type={confirmShowPassword ? 'text' : 'password'}
                        className={`pe-5 ${confirmPasswordError && 'border-danger'}`}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        onKeyUp={checkConfirmPassword}
                      />
                    </InputGroup>
                    <button className='btn-pass position-absolute end-0 top-0 text-primary h-100 px-3 bg-transparent border-0' onClick={() => setConfirmShowPassword(!confirmShowPassword)}>
                      {confirmShowPassword ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                    </button>
                  </div>
                  {confirmPasswordError && <p className='text-danger mb-2' style={{ marginTop: '-10px', paddingLeft: '40px' }}>{confirmPasswordError}</p>}
                </div>
                <a href="/purchaser-auth/forgot-password">Forgot password?</a>
                <button className='btn btn-primaryTwo w-100 mt-4' onClick={changePasswordSubmit} disabled={passwordLoader}>{!passwordLoader && "Login"}{
                  passwordLoader && 
                  <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{
                  margin: "0px 8px"
                  }}
                />
                  }</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChangePassword